export const SET_PRODUCTS = 'Products set 🤙';
export const SET_PRODUCT = 'Product set 🗃️';
export const SET_PRODUCT_DATA = 'Product data set 🏬';
export const LOADING = 'Loading ⏳';

